export default {
  select_to_share: 'Selecciona Contactos o Canales para compartir',
  forward: 'Avanzar',
  cancel: 'Cancelar',
};
